const CreateSession = async () => {
  const res = await fetch(`${process.env.REACT_APP_PHI_WEB_URL}/mirror-cast-session`, {
    method: 'POST',
  });

  const data = await res.json();
  const id = data.sessionId;

  window.location.href = `/mirror-cast/${id}?initiator=true`;
};

export default CreateSession;
